<template>
  <div class="banner_container gggl">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="loadData">
        <a-row :gutter="24">
          <a-col :md="10" :sm="10">
            <a-form-item label="公告标题">
              <a-input
                allowClear
                placeholder="请输入公告标题"
                v-model="noticeTitle"
              ></a-input>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8" style="overflow: hidden">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="loadData" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
        <a-row>
          <a-col span="24" class="banner_btns">
            <a-button type="primary" @click="handleAdd()">
              <a-icon type="plus" />新增公告
            </a-button>
            <a-button type="primary" @click="handleContactAdd()">
              <a-icon type="plus" />关联公告
            </a-button>
            <a-dropdown v-if="selectedRowKeys.length > 0">
              <a-menu slot="overlay">
                <a-menu-item @click="puDetele(selectedRowKeys)">
                  <a-icon type="primary" />批量删除</a-menu-item
                >
              </a-menu>
              <a-button style="margin-left: 8px">
                批量操作
                <a-icon type="down" />
              </a-button>
            </a-dropdown>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 表格 -->
    <a-table
      ref="tableSelect"
      :columns="columns"
      rowKey="id"
      bordered
      :scroll="{ x: 1240 }"
      :loading="loading"
      :data-source="dataSource"
      :rowSelection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange
      }"
      :pagination="ipagination"
      class="j-table-force-nowrap"
      @change="handleTableChange"
    >
      <template slot="pic" slot-scope="text, record">
        <img :src="record.pic" alt="" style="width: 80px; height: 40px" />
      </template>
      <template slot="publishFlag" slot-scope="text">
        <span v-if="text == 0">待发布</span>
        <span v-if="text == 1">已发布</span>
        <span v-if="text == 2">已过期</span>
      </template>
      <template slot="publish" slot-scope="text, record">
        <a-switch
          v-model="record.statusFlg"
          checked-children="已发布"
          un-checked-children="未发布"
          :disabled="record.isReview == 1 && record.status != 2 ? false : true"
          @click="checked => handlePublishNotice(checked, record)"
        />
      </template>
      <template slot="operation" slot-scope="text, record">
        <a href="javascript:;" @click="handleEdit(record, record.id)">编辑</a>
        <a-divider type="vertical" />
        <a
          href="javascript:;"
          :disabled="
            record.status != 2 && record.isReview == 1 && record.statusFlg == 1
              ? true
              : false
          "
          @click="onDelete(record.id)"
          >删除</a
        >
        <a-divider type="vertical" />
        <a
          href="javascript:;"
          :disabled="
            (record.isReview == 0 || record.isReview == 2) && record.status != 2
              ? false
              : true
          "
          @click="onExamine(record)"
          >审核</a
        >
      </template>
    </a-table>

    <offer-quate-Modul
      :columnChannel="columnChannel"
      :fundList="fundList"
      ref="modalForm"
      @ok="modalFormOk"
    ></offer-quate-Modul>
    <a-modal
      title="审核"
      :visible="showExamine"
      :width="800"
      @cancel="handelCancel"
      @ok="handalExamine"
    >
      <a-radio-group v-model="examineFlg" @change="examineFlgChange">
        <a-radio :value="1">审核通过</a-radio>
        <a-radio :value="2">审核驳回</a-radio>
      </a-radio-group>
      <a-textarea
        style="margin-top: 20px"
        v-show="examineFlg == 2"
        placeholder="请输入理由"
        v-model="reason"
        :auto-size="{ minRows: 2, maxRows: 6 }"
      />
    </a-modal>
    <!-- 关联公告 -->
    <a-drawer
      :width="800"
      title="新增关联公告"
      :visible="visibleShow"
      placement="right"
      :closable="true"
      :maskClosable="true"
      @close="handleCancelShow"
      style="overflow: auto; padding-bottom: 53px"
    >
      <a-table
        :rowKey="
          (record, index) => {
            return index;
          }
        "
        :rowSelection="{
          selectedRowKeys: selectedRowKey,
          onChange: onSelectChanges
        }"
        bordered
        :dataSource="addDataSourceMessage"
        :columns="columns2"
        :pagination="ipaginations"
        @change="handleTableChanges"
      >
      </a-table>
      <div class="drawer-bootom-button">
        <a-popconfirm
          title="确定放弃编辑？"
          @confirm="handleCancelShow"
          okText="确定"
          cancelText="取消"
        >
          <a-button style="margin-right: 0.8rem">取消</a-button>
        </a-popconfirm>
        <a-button @click="handleNoticeSubmit" type="primary">提交</a-button>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import { setColumnDeleteBatch, queryByFundCode } from '@/api/api';
import '@/assets/less/TableExpand.less';
import { mixinDevice } from '@/utils/mixin';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import offerQuateModul from './offerQuateModul';
import { getAction, postAction, postTag } from '@/api/manage';

const columns = [
  {
    align: 'center',
    title: '公告标题',
    dataIndex: 'title',
    key: 'title',
    ellipsis: true,
    width: 150
  },
  {
    align: 'center',
    title: '上架渠道栏目',
    dataIndex: 'channelColumnList',
    ellipsis: true,
    width: 150,
    customRender: text => {
      if (!text) {
        return '--';
      } else {
        let str = [];
        text.forEach(item => {
          str.push(item.columnName);
        });
        return str.length > 0 ? str.join(',') : '--';
      }
    }
  },
  {
    align: 'center',
    title: '关联产品',
    dataIndex: 'fundList',
    ellipsis: true,
    width: 200,
    customRender: text => {
      let obj = JSON.parse(sessionStorage.getItem('productParticulars'));
      return obj.fundName;
      // let str = [];
      // text.forEach(item => {
      //   str.push(item.fundName);
      // });
      // return str.length > 0 ? str.join(',') : '--';
    }
  },

  {
    align: 'center',
    title: '审核状态',
    dataIndex: 'isReview',
    customRender: text => {
      return text == 0 ? '待审核' : text == 1 ? '审核通过' : '审核驳回';
    },
    width: 100
  },
  {
    align: 'center',
    title: '是否失效',
    dataIndex: 'isExpire',
    customRender: text => {
      return text == true ? '已失效' : '未失效';
    },
    width: 100
  },
  {
    align: 'center',
    title: '拒绝理由',
    dataIndex: 'reason',
    customRender: text => {
      return !text || text == '' ? '--' : text;
    },
    ellipsis: true,
    width: 200
  },
  {
    align: 'center',
    title: '发布状态',
    dataIndex: 'status',
    scopedSlots: {
      customRender: 'publishFlag'
    },
    width: 80
  },
  {
    align: 'center',
    title: '是否发布',
    dataIndex: 'publish',
    scopedSlots: {
      customRender: 'publish'
    },
    width: 120
  },
  {
    align: 'center',
    title: '操作',
    key: 'operation',
    width: 220,
    fixed: 'right',
    scopedSlots: {
      customRender: 'operation'
    }
  }
];
const columns2 = [
  {
    title: '公告标题',
    dataIndex: 'title',
    align: 'title'
  },
  {
    title: '公告类型',
    dataIndex: 'noticeType',
    align: 'noticeType',
    customRender: text => {
      return text == 0 ? '产品资讯' : '普通资讯';
    }
  }
];
export default {
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    offerQuateModul
  },
  data() {
    return {
      columns2, ///可关联公告table数据
      addDataSourceMessage: [], //可关联公告
      ipaginations: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      selectedRowKeys: [],
      selectionRows: [],
      selectedRowKey: [],
      selectionRow: [],
      visibleShow: false,
      noticeTitle: '', //公告标题
      columns,
      routerFundCode: '',
      form: this.$form.createForm(this, {
        name: 'advanced_search'
      }),
      selectedRowKeys: [],
      loading: false,
      columnChannel: [],
      queryColumnChannel: [],
      fundList: {},
      url: {
        noticeAdd: process.env.VUE_APP_CMS_PRODUCT + '/product/notice/add', //添加关联的公告
        contactNotice: process.env.VUE_APP_CMS_PRODUCT + '/product/notice/list', //可关联的公告
        list: process.env.VUE_APP_CMS_PRODUCT + '/product/notice/page',
        delete: process.env.VUE_APP_CMS_CONTENT + '/content/notice/del',
        deleteBatch:
          process.env.VUE_APP_CMS_CONTENT + '/content/notice/delBatch',
        publishNotice: process.env.VUE_APP_CMS_CONTENT + '/content/notice/put',
        reviewNotice: process.env.VUE_APP_CMS_CONTENT + '/content/notice/review'
      },
      showExamine: false, //审核弹窗
      examineFlg: 1, //1-审核通过 2-审核拒绝
      reason: '', //审核拒绝理由
      currentExamine: {} //当前要审核的数据
    };
  },
  created() {
    this.initData();
    this.loadData();
  },
  methods: {
    //关联公告
    handleContactAdd() {
      this.visibleShow = true;
      this.getContactNotice();
      console.log(this.visibleShow);
    },
    //关联公告弹窗关闭点击事件
    handleCancelShow() {
      this.visibleShow = false;
      this.onClearSelected();
    },
    //清空选中的数据
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
      this.selectionRow = [];
      this.selectedRowKey = [];
    },
    // 获取点中时的数据
    onSelectChanges(selectedRowKeys, selectionRows) {
      this.selectedRowKey = selectedRowKeys;
      this.selectionRow = selectionRows;
    },
    //获取可关联的公告
    getContactNotice() {
      let that = this;
      let param = {
        pageNo: this.ipaginations.current,
        pageSize: this.ipaginations.pageSize,
        fundCode: this.$route.query.fundCode
      };
      postTag(that.url.contactNotice, param).then(res => {
        that.loading = true;
        if (res.success) {
          that.addDataSourceMessage =
            res.result && res.result.records ? res.result.records : [];
          that.ipaginations.total = res.result.total;
          that.loading = false;
        }
      });
    },
    //提交关联公告
    handleNoticeSubmit() {
      let that = this;
      let result = {
        fundCode: this.$route.query.fundCode
      };
      let proxycode = [];
      if (this.selectionRow.length <= 0) {
        return that.$message.warning('请选择一条记录');
      }
      this.selectionRow.forEach(item => {
        proxycode.push(item.id);
      });
      result.noticeIds = proxycode;
      postTag(that.url.noticeAdd, result).then(res => {
        if (res.success) {
          that.loading = false;
          that.visibleShow = false;
          that.onClearSelected();
          that.loadData(1);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    puDetele(ids) {
      this.$confirm({
        title: '确认',
        content: '确定要批量删除吗?',
        onOk: () => {
          postAction(this.url.deleteBatch, {
            ids: ids.join(',')
          }).then(res => {
            if (res.success) {
              this.$message.success(res.message);
              this.loadData(1);
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },
    loadData(arg) {
      if (arg === 1) {
        this.ipagination.current = 1;
      }
      //加载数据 若传入参数1则加载第一页的内容
      let params = {
        fundCode: this.$route.query.fundCode,
        pageNo: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
        title: this.noticeTitle
      };

      this.loading = true;
      postTag(this.url.list, params).then(res => {
        this.loading = false;
        if (res.success) {
          this.dataSource =
            res.result && res.result.records ? res.result.records : [];
          if (this.dataSource.length > 0) {
            this.dataSource.forEach(item => {
              item.statusFlg = item.status == 0 ? false : true;
            });
          }

          this.ipagination.total = res.result.total;
        }
        if (res.code === 510) {
          this.$message.warning(res.message);
        }
      });
    },
    initData() {
      getAction(
        process.env.VUE_APP_CMS_CONTENT + '/content/column/queryByChannel',
        { channelCode: 'pc_service' }
      ).then(res => {
        if (res.success) {
          this.columnChannel = res.result;
          this.queryColumnChannel = JSON.parse(JSON.stringify(res.result));
          this.handleColumnValue(this.queryColumnChannel);
        }
      });
      queryByFundCode().then(res => {
        if (res.success) {
          this.fundList = res.result.records;
          console.log(res, '关联产品');
        }
      });
    },
    handleColumnValue(queryColumnChannel) {
      for (let index in queryColumnChannel) {
        let item = queryColumnChannel[index];
        item.value = item.code;
        if (item.children && item.children.length > 0) {
          this.handleColumnValue(item.children);
        }
      }
    },
    // 删除
    onDelete(id) {
      let that = this;
      this.$confirm({
        title: '确认删除',
        content: '是否删除选中数据?',
        onOk: function() {
          that.loading = true;
          postAction(that.url.delete, { id: id })
            .then(res => {
              if (res.success) {
                that.$message.success(res.message);
                that.loadData(1);
              } else {
                that.$message.error(res.message);
              }
            })
            .finally(() => {
              that.loading = false;
            });
        }
      });
    },
    handlePublishNotice(checked, record) {
      postAction(this.url.publishNotice, {
        id: record.id,
        status: checked ? 1 : 0
      }).then(res => {
        if (res.success) {
          this.loadData(1);
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    onExamine(record) {
      this.showExamine = true;
      this.currentExamine = record;
    },
    examineFlgChange(e) {
      this.examineFlg = e.target.value;
    },
    //提交审核
    handalExamine() {
      postAction(this.url.reviewNotice, {
        id: this.currentExamine.id,
        review: this.examineFlg,
        reason: this.reason
      }).then(res => {
        if (res.success) {
          this.showExamine = false;
          this.loadData(1);
          //重置审核框
          this.examineFlg = 1;
          this.reason = '';
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //取消审核
    handelCancel() {
      this.showExamine = false;
      //重置审核框
      this.examineFlg = 1;
      this.reason = '';
    },
    //重置
    searchReset() {
      this.noticeTitle = '';
      this.loadData();
    },
    handleTableChanges(pagination) {
      console.log(pagination);
      this.onClearSelected(); //分页切换时清空表格选中
      this.ipaginations = pagination;
      this.loadData();
      this.getContactNotice();
    }
  }
};
</script>

<style scoped lang="less">
.banner_container {
  background: #fff;
  padding: 25px;

  .lm {
    z-index: 999;
  }

  .banner_title {
    border-bottom: 1px solid #ddd;
    padding-bottom: 10px;
    font-size: 22px;
    color: #333;
    margin-bottom: 20px;
  }

  .banner_btns {
    margin-bottom: 20px;

    .ant-btn {
      margin-right: 10px;
    }
  }

  .ant-table-wrapper {
    margin-bottom: 30px;
  }

  .bannerImg {
    display: flex;

    .img_item {
      width: 250px;
      height: 170px;

      img {
        display: inline-block;
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
<style lang="less">
.gggl {
  .ant-select-open .ant-select-selection,
  .lm .ant-select-selection--multiple {
    max-height: 104px;
    overflow-y: scroll;
  }
}
.edit-upload {
  margin-left: 136px;
  margin-bottom: 23px;

  .pdf {
    color: #999;
    margin-left: 10px;
  }
}
</style>
